import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PageError from '../error/pageError';
import { ManagerContextProvider } from '../manager/components/context';
import ProductList from './list/productList';

export default class ProductOrganization extends React.Component {
    render() {
        const { path, organization } = this.props;

        return (
            <ManagerContextProvider>
                <Switch>
                    <Route exact path={`${path}/`} render={() => <ProductList organization={organization} />} />
                    {/* Error */}
                    <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
                </Switch>
            </ManagerContextProvider>
        );
    }
}

ProductOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
